/* 备课 */
export default [
  {
    path: "/ready",
    name: "ready",
    redirect: "/ready/home",
    component: () => import("@/views/ready-course/layout"),
    children: [
      {
        // 首页
        path: "/ready/home",
        name: "readyHome",
        component: () => import("@/views/ready-course/index"),
      },
      {
        // 课程建设
        path: "/ready/index",
        name: "readyIndex",
        component: () => import("@/views/ready-course/jxCourse/index"),
      },
      {
        // 课程建设教研组
        path: "/ready/group",
        name: "readyGroup",
        component: () => import("@/views/ready-course/jxCourse/courseGroup"),
      },
      {
        // 课程建设目录
        path: "/ready/chapter",
        name: "readyChapter",
        redirect: "/ready/chapter/index",
        component: () => import("@/views/ready-course/jxCourse/courseChapter"),
        children: [
          {
            path: "/ready/chapter/index",
            name: "readyChapterIndex",
            component: () =>
              import("@/views/ready-course/jxCourse/chapterIndex"),
          },
          {
            path: "/ready/chapter/library",
            name: "readyChapterLibrary",
            component: () =>
              import("@/views/ready-course/jxCourse/chapterLibrary"),
          },
          {
            path: "/ready/chapter/res",
            name: "readyChapterRes",
            component: () => import("@/views/ready-course/jxCourse/chapterRes"),
          },
          {
            path: "/ready/chapter/img",
            name: "readyChapterImg",
            component: () => import("@/views/ready-course/jxCourse/chapterImg"),
          },
          {
            path: "/ready/chapter/link",
            name: "readyChapterLink",
            component: () =>
              import("@/views/ready-course/jxCourse/chapterLink"),
          },
          {
            path: "/ready/chapter/h5",
            name: "readyChapterH5",
            component: () => import("@/views/ready-course/jxCourse/chapterH5"),
          },
        ],
      },
      {
        // 授课计划
        path: "/ready/skPlan",
        name: "readySkPlan",
        component: () => import("@/views/ready-course/skPlan/index"),
      },
      {
        // 授课计划-添加、编辑、修改
        path: "/ready/skPlan/add",
        name: "readySkPlanAdd",
        component: () => import("@/views/ready-course/skPlan/add"),
      },
      {
        // 授课计划 - 查看
        path: "/ready/skPlan/view",
        name: "readySkPlanView",
        redirect: "/ready/SkPlan/view/plan",
        component: () => import("@/views/ready-course/skPlan/view"),
        children: [
          {
            path: "/ready/skPlan/view/plan",
            name: "readySkPlanViewPlan",
            component: () => import("@/views/ready-course/skPlan/viewPlan"),
          },
          {
            path: "/ready/skPlan/view/con",
            name: "readySkPlanViewCon",
            component: () => import("@/views/ready-course/skPlan/viewCon"),
          },
        ],
      },
      {
        // 预习任务
        path: "/ready/yxtask",
        name: "readyYXTask",
        component: () => import("@/views/ready-course/yxTask/index"),
      },
      {
        // 预习任务添加
        path: "/ready/yxtask/add",
        name: "readyYXTaskAdd",
        component: () => import("@/views/ready-course/yxTask/taskAdd"),
      },
      {
        // 预习任务详情---添加测试
        path: "/ready/detail/add/test",
        name: "readyYXTaskAddTest",
        component: () => import("@/views/ready-course/yxTask/addTest"),
      },
      {
        // 预习任务详情
        path: "/ready/detail",
        name: "readyYXTaskDetail",
        redirect: "/ready/detail/info",
        component: () => import("@/views/ready-course/yxTask/taskDetail"),
        children: [
          {
            // 预习任务详情---基本信息
            path: "/ready/detail/info",
            name: "readyYXTaskDetailInfo",
            component: () => import("@/views/ready-course/yxTask/taskInfo"),
          },
          {
            // 预习任务详情---留言
            path: "/ready/detail/msg",
            name: "readyYXTaskDetailMsg",
            component: () => import("@/views/ready-course/yxTask/taskMsg"),
          },
          {
            // 预习任务详情---测试
            path: "/ready/detail/testInfo",
            name: "readyYXTaskDetailTest",
            component: () => import("@/views/ready-course/yxTask/taskTest"),
          },
          {
            // 预习任务详情---学生详情表格
            path: "/ready/detail/table",
            name: "readyYXTaskDetailTable",
            component: () => import("@/views/ready-course/yxTask/taskTable"),
          },
          {
            // 预习任务详情---讨论
            path: "/ready/detail/discuss",
            name: "readyYXTaskDiscuss",
            component: () => import("@/views/ready-course/yxTask/taskDiscuss"),
          },
          {
            // 预习任务详情---问卷
            path: "/ready/detail/question",
            name: "readyYXTaskQuestion",
            component: () => import("@/views/ready-course/yxTask/taskQuestion"),
          },
          {
            // 预习任务详情---资源
            path: "/ready/detail/resource",
            name: "readyYXTaskResource",
            component: () => import("@/views/ready-course/yxTask/taskResource"),
          },
          {
            // 预习任务详情---测验
            path: "/ready/detail/test",
            name: "readyYXTaskTest",
            component: () => import("@/views/ready-course/yxTask/taskTests"),
          },
        ],
      },
      {
        // 课中活动
        path: "/ready/kzActivity",
        name: "readyKZActivity",
        component: () => import("@/views/ready-course/kzActivity/index"),
        redirect: "/ready/kzActivity/sign",
        children: [
          {
            // 课中活动---签到考勤
            path: "/ready/kzActivity/sign",
            name: "readyKZActivitySign",
            component: () => import("@/views/ready-course/kzActivity/sign"),
          },
          {
            // 课中活动---课堂表现
            path: "/ready/kzActivity/show",
            name: "readyKZActivityShow",
            component: () => import("@/views/ready-course/kzActivity/show"),
          },
          {
            // 课中活动---讨论
            path: "/ready/kzActivity/discuss",
            name: "readyKZActivityDiscuss",
            component: () => import("@/views/ready-course/kzActivity/discuss"),
          },
          {
            // 课中活动---问卷
            path: "/ready/kzActivity/ques",
            name: "readyKZActivityQues",
            component: () => import("@/views/ready-course/kzActivity/ques"),
          },
          {
            // 课中活动---投票表决
            path: "/ready/kzActivity/vote",
            name: "readyKZActivityVote",
            component: () => import("@/views/ready-course/kzActivity/vote"),
          },
          {
            // 课中活动---学生互评
            path: "/ready/kzActivity/mutualEvaluate",
            name: "readyKZActivityMutualEvaluate",
            component: () =>
              import("@/views/ready-course/kzActivity/mutualEvaluate"),
          },
          {
            // 课中活动---过程性评价
            path: "/ready/kzActivity/processEvaluate",
            name: "readyKZActivityProcessEvaluate",
            component: () =>
              import("@/views/ready-course/kzActivity/processEvaluate"),
          },
          {
            // 课中活动---随堂测验
            path: "/ready/kzActivity/test",
            name: "readyKZActivityProcessTest",
            component: () => import("@/views/ready-course/kzActivity/test"),
          },
          {
            // 课中活动---随堂测验添加
            path: "/ready/kzActivity/test/add",
            name: "readyKZActivityProcessTestAdd",
            component: () => import("@/views/ready-course/kzActivity/addTest"),
          },
          {
            // 课中活动---随堂测验详情
            path: "/ready/kzActivity/test/detail",
            name: "readyKZActivityProcessTestDetail",
            component: () => import("@/views/components/taskTest"),
          },
        ],
      },
      {
        // 课后拓展
        path: "/ready/expand/index",
        name: "readykhExpand",
        component: () => import("@/views/ready-course/khExpand/index"),
      },
      {
        // 新增测验
        path: "/ready/expand/addTest",
        name: "readykhExpandAddTest",
        component: () => import("@/views/ready-course/khExpand/addTest"),
      },
      {
        // 新增编辑作业
        path: "/ready/expand/addWork",
        name: "readykhExpandAddWork",
        component: () => import("@/views/ready-course/khExpand/addWork"),
      },
      {
        // 作业详情
        path: "/ready/expand/viewWork",
        name: "readykhExpandviewWork",
        component: () => import("@/views/ready-course/khExpand/viewWork"),
      },
      {
        // 作业批阅
        path: "/ready/expand/workReview",
        name: "readykhExpandworkReview",
        component: () => import("@/views/ready-course/khExpand/workReview"),
      },
      {
        // 课后拓展作业详情
        path: "/ready/expand/detailWork",
        name: "readykhExpandDetailWork",
        component: () => import("@/views/ready-course/khExpand/detailWork"),
      },
      {
        // 课后拓展测验详情
        path: "/ready/expand/detailTest",
        name: "readykhExpandDetailTest",
        component: () => import("@/views/ready-course/khExpand/detailTest"),
      },
      {
        // 教学班级
        path: "/ready/jxClass",
        name: "readyJXClass",
        component: () => import("@/views/ready-course/jxClass/index"),
      },
      {
        // 教学班级---详情
        path: "/ready/jxClass/detail",
        name: "readyJXClassDetail",
        component: () => import("@/views/ready-course/jxClass/classDetail"),
      },
      {
        // 在线答疑
        path: "/ready/zxAnswering",
        name: "readyZXAnswering",
        component: () => import("@/views/ready-course/zxAnswering/index"),
      },
      {
        // 课程评价
        path: "/ready/courseEvaluation",
        name: "readyCourseEvaluation",
        component: () => import("@/views/ready-course/courseEvaluation/index"),
      },
      {
        // 个人中心
        path: "/user",
        name: "userContent",
        component: () => import("@/components/BaseUserContent"),
      },
      {
        // 聊天
        path: "/chat",
        name: "chat",
        component: () => import("@/views/ready-course/chat"),
      },
      {
        // 教学成效
        path: "/ready/jxeffect",
        name: "readyJxeffect",
        component: () => import("@/views/ready-course/jxeffect/index"),
      },
      {
        // 学生个人画像
        path: "/ready/stuPortrayal",
        name: "readystuPortrayal",
        component: () => import("@/views/ready-course/jxeffect/stuPortrayal"),
      },
      {
        // 学生预习情况更多
        path: "/ready/stuPortrayal/prepare",
        name: "readystuPortrayalPrepare",
        component: () =>
          import("@/views/ready-course/jxeffect/more/prepareMore"),
      },
      {
        // 学生测验情况更多
        path: "/ready/stuPortrayal/test",
        name: "readystuPortrayalTest",
        component: () => import("@/views/ready-course/jxeffect/more/testMore"),
      },
      {
        // 学生作业情况更多
        path: "/ready/stuPortrayal/job",
        name: "readystuPortrayalJob",
        component: () => import("@/views/ready-course/jxeffect/more/jobMore"),
      },
      {
        //班级教学明细表
        path: "/teach/detail1",
        name: "teachDetail1",
        component: () => import("@/views/ready-course/jxeffect/more/teachDetail"),
      },
      {
        //过程性评价详情表
        path: "/teach/moreEvaluation1",
        name: "moreEvaluation1",
        component: () =>
          import("@/views/ready-course/jxeffect/more/moreEvaluation"),
      },
      {
        //更多学生学习进度
        path: "/teach/moreStuLearning1",
        name: "moreStuLearning1",
        component: () =>
          import("@/views/ready-course/jxeffect/more/moreStuLearning"),
      },
      {
        // 活跃度配置
        path: "/ready/activity",
        name: "readyActivity",
        component: () => import("@/views/ready-course/activity"),
      },
    ],
  },
];
